export default "__VITE_ASSET__CbjrdmQE__"